<template>
  <div id="loginLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'loginLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/login/LoginLog.vue